/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/calendar';

/**
 * displayCalendar
 * url - /checkout/{apiversion}/cart/{cartId}/calendar?brand={brandId}&cartItemId={cartItemId}&startDate={startDate}
 *
 * @param {Object} args
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.cartItemId
 * @param {String} args.startDate
 */
const displayCalendar = ({
    env,
    jwtToken,
    cartId,
    cartItemId,
    startDate,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    let displayCalendarParam = '';

    if (cartItemId) {
        displayCalendarParam = `?cartItemId=${cartItemId}&startDate=${startDate}`;
    }

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}${displayCalendarParam}`;

    return restClient.getRequest(envObj, resourcePage, jwtToken)
        .then((response) => response);
};

export default displayCalendar;
